import script from "./NotarialActionCalculation.vue?vue&type=script&setup=true&lang=js"
export * from "./NotarialActionCalculation.vue?vue&type=script&setup=true&lang=js"

import "./NotarialActionCalculation.vue?vue&type=style&index=0&id=54dd344b&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54dd344b"]])

export default __exports__